"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SimpleTypeahead = require("./SimpleTypeahead");
Object.keys(_SimpleTypeahead).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SimpleTypeahead[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SimpleTypeahead[key];
    }
  });
});
var _Typeahead = require("./Typeahead");
Object.keys(_Typeahead).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Typeahead[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Typeahead[key];
    }
  });
});